import { CanadaPurchaseCost } from '../purchase-cost'

export const OntarioPurchaseCost = {
  ...CanadaPurchaseCost,
} as const
